import React from 'react';
import {Scrollbars} from "react-custom-scrollbars";
import {saveAs} from 'file-saver';
import htmlDocx from 'html-docx-js/dist/html-docx';
import {formatTime} from "../../../../../utils";
import BaseComponent from "../../../../../base/BaseComponent";
import DOMPurify from 'dompurify'; // 引入DOMPurify库

class ContentView extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            content: '',
            id: "",
            currentData: {},
            mediaData: {},
            title: ""
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        let urlParams = this.urlParams;
        let body = {
            contentId: urlParams.contentId,
            typeId: urlParams.positionTypeId
        }
        this.request({
            url: '/cm-sites-media-consumer/position/content/manager/getById',
            body: body,
            method: "get",
            callBack: (data) => {
                if (data) {
                    this.setState({
                        content: data.cmSiteContent,
                        currentData: data,
                        title: data.title,
                        id: data.id,
                        mediaData: urlParams.mediaData
                    })
                }
            }
        })
    }

    async downloadWord() {
        try {
            const {title, content} = this.state;
            const cleanContent = DOMPurify.sanitize(content); // 使用DOMPurify净化HTML
            const processedContent = await this.processHtmlForWord(cleanContent);
            const blob = await htmlDocx.asBlob(processedContent);
            saveAs(blob, `${title}.docx`);
        } catch (error) {
            console.error('Error downloading Word:', error);
        }
    }

    async processHtmlForWord(htmlContent) {
        const virtualElement = document.createElement('div');
        virtualElement.innerHTML = htmlContent;

        const imgElements = virtualElement.querySelectorAll('img');
        const promises = Array.from(imgElements).map(img => this.processImage(img));
        await Promise.all(promises);

        return virtualElement.innerHTML;
    }

    async processImage(img) {
        const currentSrc = img.getAttribute('src');
        if (currentSrc && currentSrc.startsWith('/storage')) {
            const image = new Image();
            image.src = window.location.origin + currentSrc;
            return new Promise((resolve, reject) => {
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const newWidth = image.width * 0.5;
                    const newHeight = image.height * 0.5;
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    ctx.drawImage(image, 0, 0, newWidth, newHeight);
                    img.setAttribute('src', canvas.toDataURL('image/png'));
                    img.setAttribute('width', newWidth);
                    img.setAttribute('height', newHeight);
                    resolve();
                };
                image.onerror = reject;
            });
        }
    }


    download() {
        let body = {contentId: this.urlParams.contentId, typeId: this.urlParams.positionTypeId};
        this.request({
            url: '/cm-sites-media-consumer/position/content/manager/downloadById',
            body: body,
            contentType: 'json',
            method: "downloadGet",
            callBack: (res) => {
            console.log("🚀 ~ ContentView ~ download ~ res:", res)
            },
            errorCallBack: (e) => {
            },
        })
    }

    render() {
        let {currentData = {}, mediaData = {}} = this.state;
        const style = {
            marginBottom: '10px',
            width: '120px',
            backgroundColor: '#fff',
            padding: '5px 10px',
            cursor: 'pointer',
            color: '#000',
            border: '1px solid #ccc',
            textAlign: 'center',
            borderRadius: '5px',
        };
        const DownloadButton = ({text, onClick}) => (
            <div style={style} onClick={onClick}>
                {text}
            </div>
        );
        let htmlContent = this.state.content;
        if (!htmlContent) {
            return ""
        }
        htmlContent = htmlContent.replace(/<img(.*?)>/g, function (match, p1) {
            if (p1.includes('style')) {
                return match.replace('style="', 'style="max-width:100%;');
            } else {
                return match.replace('>', ' style="max-width:100%;">');
            }
        });
        return (
            <div style={{maxWidth: 900, margin: "15px auto", display: "flex",}}>
                <Scrollbars autoHeight autoHeightMax={'calc(100vh - 100px)'} style={{borderRadius: "5px"}}>
                    <div style={{backgroundColor: "#fff", padding: "15px"}}>
                        <div style={{fontSize: '22px', fontWeight: 700}}>
                            {currentData.title || ""}
                        </div>
                        <div style={{fontSize: '16px', margin: '20px 0'}}>
                            {mediaData.logo && <span style={{marginRight: 10}}><img
                                style={{width: 20, height: 20, verticalAlign: 'text-bottom'}}
                                src={mediaData.logo}/></span>}
                            {currentData.mediaName && <span
                                style={{color: 'rgb(120, 139, 177)', marginRight: 10}}>{currentData.mediaName}</span>}
                            {currentData.publishTime && <span
                                style={{color: '#ccc'}}>{formatTime(currentData.publishTime)}</span>}
                        </div>
                        <div style={{clear: "both"}}/>
                        <div dangerouslySetInnerHTML={{__html: htmlContent}}/>
                    </div>
                </Scrollbars>
                {mediaData.type === 2 &&
                    <div style={{marginLeft: 20}}>
                        <DownloadButton text="下载为word" onClick={() => this.downloadWord()}/>
                        <DownloadButton text="下载为压缩包" onClick={() => this.download()}/>
                    </div>}
            </div>
        );
    }
}

export default ContentView;